<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page page-policy">
                <div class="container">
                    <div class="page-title">Пользовательское соглашение об использовании сервиса Астропроцессор Maya
                    </div>
                    <div class="page-doc-text">

                        <p class="h2">1. ОБЩИЕ ПОЛОЖЕНИЯ</p>
                        <p>1.1. ИП Андреев Виктор Александрович (далее — Компания) предлагает пользователю сети Интернет
                            (далее — Пользователь) использовать сервис «Астропроцессор Maya», доступный по адресу <a
                                    href="http://www.maya1.ru" target="_blank">http://www.maya1.ru</a> (далее —
                            «Сервис»). Сервис предоставляется Пользователю для личного некоммерческого использования.
                        </p>
                        <p>1.2. Настоящее Соглашение представляет собой соглашение относительно порядка использования
                            Сервиса.</p>
                        <p>1.3. Начиная использовать Сервис/его отдельные функции, Пользователь считается принявшим
                            настоящее Соглашение в полном объеме и без исключений. В случае несогласия Пользователя с
                            какими-либо из положений указанных документов, Пользователь не вправе использовать
                            Сервис.</p>
                        <p>1.4. Настоящее Соглашение Компания может изменить без какого-либо специального уведомления,
                            новая редакция Соглашения вступает в силу с момента ее размещения в сети Интернет по адресу
                            <a href="http://www.maya1.ru" target="_blank">http://www.maya1.ru</a>, если иное не
                            предусмотрено новой редакцией Соглашения.</p>
                        <p>1.5. В случае, если Компания внесет какие-либо изменения в настоящее Соглашение, в порядке,
                            предусмотренном п. 1.4. настоящего Соглашения, с которыми Пользователь не согласен, он
                            обязан прекратить использование Сервиса.</p>
                        <p>1.6. Сервис предлагает Пользователю возможность построить натальную карту и бодиграф по
                            введенным данным о дате, времени и месте рождения, а также сохранять построенные
                            карту/бодиграф на Сервисе. Все существующие на данный момент функции Сервиса, а также любое
                            развитие их и/или добавление новых является предметом настоящего Соглашения.</p>
                        <p>1.7. За использование отдельных услуг Сервиса может быть установлена плата. Порядок
                            определения стоимости и условия получения услуг регламентируются на странице Тарифы <a
                                    href="http://www.maya1.ru" target="_blank">http://www.maya1.ru</a>. Денежные
                            средства, внесенные Пользователем за подключение к Сервису, возврату не подлежат.</p>

                        <p class="h2">2. ПЕРСОНАЛЬНЫЕ ДАННЫЕ</p>
                        <p>2.1. Предоставляя свои персональные данные, Пользователь соглашается на их обработку и
                            дальнейшее использование/предоставление, в том числе третьими лицами в рамках работы
                            сервиса.</p>
                        <p>2.2. Целью обработки персональной информации Пользователя является оказание услуг
                            Сервиса.</p>
                        <p>2.3. Компания вправе посылать своим пользователям сообщения информационно-рекламного
                            характера.</p>
                        <p>2.4. Пользователь самостоятельно несет ответственность за безопасность несанкционированного
                            доступа к Сервису, а также самостоятельно обеспечивает конфиденциальность доступа.</p>
                        <p>2.5. Компания оставляет за собой право по своему усмотрению ограничить доступ Пользователя к
                            Сервису (или к определенным функциям Сервиса, если это возможно технологически) с
                            использованием его учетной записи или полностью заблокировать учетную запись
                            Пользователя.</p>

                        <p class="h2">3. ОТВЕТСТВЕННОСТЬ СТОРОН</p>
                        <p>3.1. Компания оставляет за собой право по своему усмотрению ограничить доступ Пользователя к
                            Сервису (или к определенным функциям Сервиса) с использованием его учетной записи, или
                            полностью заблокировать учетную запись Пользователя.</p>
                        <p>3.2. Администрация Сервиса не несет перед Пользователем ответственность в случае полной или
                            частичной неработоспособности системы и компонентов Сервиса в течение какого-либо времени, а
                            также при отсутствии возможности доступа Пользователя к функционалу Сервиса.</p>

                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';

    export default {
        name: "TermsOfUse",

        components: {
            Header, Footer
        },

        data() {
            return {}
        }
    }
</script>